export const checkObjectNotEmpty = (
  object: Record<string, string | string[]>
) => {
  return !!(object && Object.keys(object).length > 0);
};
